import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { Fleet } from '../../common/Fleet';
import { staggeredBaseQuery } from './staggeredBaseQuery'; 

export const fleetApi = createApi({
  reducerPath: 'fleetApi',
  tagTypes: ['Fleet'],
  baseQuery: staggeredBaseQuery(''),
  endpoints: (builder) => ({
    getFleets: builder.query<Fleet[], {}>({
      query: () => {
        return {
          method: 'GET',
          url: 'fleets/'
        };
      },
      providesTags: (result) =>
        result
        ? [
            ...result.map(({ id }) => ({ type: 'Fleet' as const, id })),
            { type: 'Fleet', id: 'LIST' },
          ]
        : [{ type: 'Fleet', id: 'LIST' }],
    }),
    getFleet: builder.query<Fleet, String>({
      query: (fleetId) => {
        return {
          method: 'GET',
          url: `fleets/${fleetId}`,
        };
      },
    }),
    createFleet: builder.mutation<Fleet, Partial<Fleet>>({
      query: (fleet) => {
        return {
          method: 'POST',
          url: 'fleets/',
          body: fleet,
        };
      },
      invalidatesTags: [{ type: 'Fleet', id: 'LIST' }],
    }),
    updateVessel: builder.mutation<Fleet, { fleetId: string, fleet: Partial<Fleet>}>({
      query: ({fleetId, fleet}) => {
        return {
          method: 'PUT',
          url: `fleets/${fleetId}`,
          body: fleet,
        };
      },
      invalidatesTags: (result, error, { fleetId }) => [{ type: 'Fleet', id: fleetId }],
    }),
  }),
});

export const {
  useGetFleetQuery,
  useGetFleetsQuery,
  useCreateFleetMutation,
  useUpdateVesselMutation,
} = fleetApi;